import { mutation } from '@/dex-shared/helpers/graphql';

export default {
  async CREATE_COURSE_BOARD(
    { commit },
    {
      description,
      suggestedPeriod,
      courseId,
      boardId,
    }: {
      description: string;
      suggestedPeriod: number;
      courseId: number;
      boardId: number;
    },
  ) {
    let response = await mutation(
      `mutation CreateCourseBoard($description: String, $suggestedPeriod: Int, $courseId: Int!, $boardId: Int!) {
        createCourseBoard(input:
        {
          courseBoard: {
            description: $description,
            suggestedPeriod: $suggestedPeriod,
            courseId: $courseId,
            boardId: $boardId,
          }
        })
        {
          courseBoard {
            id
          }
        }
      }`,
      {
        description,
        suggestedPeriod,
        courseId,
        boardId,
      },
    );
    commit('UPDATE_ENTITY', {
      entity: 'course_boards',
      data: response.data.createCourseBoard.courseBoard,
    });
    return response.data.createCourseBoard.courseBoard.id;
  },

  async PUSH_COURSE_BOARD_BY_ID(
    { getters }: any,
    courseBoard: {
      id: number;
      description: string;
      suggestedPeriod: number;
    },
  ) {
    await mutation(
      `
      mutation dexAdminUpdateCourseBoardById($id: Int!, $description: String, $suggestedPeriod: Int) {
        updateCourseBoardById(input: {
          id: $id,
          courseBoardPatch: {
            description: $description
            suggestedPeriod: $suggestedPeriod
          }
        }){
          courseBoard{
            id
          }
        }
      }`,
      {
        ...courseBoard,
      },
    );
  },

  async DELETE_COURSE_BOARD(_: any, courseBoardId: number) {
    await mutation(
      `
      mutation dexAdminDeleteCourseBoardById($courseBoardId: Int!) {
        deleteCourseBoardById(input: {
          id: $courseBoardId
        }){
          courseBoard{
            id
          }
        }
      }`,
      {
        courseBoardId,
      },
    );
  },
};
